import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showFilter: '=',
        filter: '=',
        list: '='
    },
    template: `
    <div class="table-filters">
        <form ng-submit="vm.applyFilter()" class="form form-filter"  ng-if="vm.showFilter">
            <div class="fields">
                <div class="row row-md">
                    <label class="label">{{ 'tasklist.Employee name' | translate }}</label>
                    <div class="items">
                        <input ng-model="vm.filter.employeeName" type="text" class="form-control">
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'tasklist.Status' | translate }}</label>
                    <div class="items">
                        <div ng-dropdown-multiselect=""
                            options="vm.multiFilter.statuses.options"
                            selected-model="vm.multiFilter.statuses.model"
                            extra-settings="vm.multiFilter.statuses.settings"
                            translation-texts="vm.filterTranslations"
                        ></div>
                    </div>
                </div>
            </div>
            <ul class="actions01">
                <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
            </ul>
        </form>
    </div>
    `
})
export default class {
    constructor (lodash, FilterService, TASKLIST_STATUS_ENUM) {
        this.lodash = lodash;
        this.FilterService = FilterService;
        this.TASKLIST_STATUS_ENUM = TASKLIST_STATUS_ENUM;
    }

    $onInit () {
        this.initFilters();
        this.filterTranslations = this.FilterService.getTranslations();
        this.defaultFilter = angular.copy(this.filter);
        this.defaultMultiFilter = angular.copy(this.multiFilter);
        this.applyFilter();
    }

    applyFilter () {
        if (this.multiFilter.statuses.model.length) {
            this.filter = this.lodash.assign(this.filter, { 'statuses[]': this.multiFilter.statuses.model.map(status => status.value) });
        }
        else {
            delete this.filter['statuses[]'];
        }

        this.list.fetch(this.filter);
    }
    initFilters () {
        const statusOptions = [
            {
                value: this.TASKLIST_STATUS_ENUM.KEYS.INCOMPLETE,
                label: this.TASKLIST_STATUS_ENUM.LABELS.INCOMPLETE
            },
            {
                value: this.TASKLIST_STATUS_ENUM.KEYS.COMPLETED,
                label: this.TASKLIST_STATUS_ENUM.LABELS.COMPLETED
            }
        ];

        const statusOptionsSelected = [statusOptions[0]];
        this.multiFilter = {
            statuses: {
                model: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: itemText => itemText
                }
            }
        };
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/tasklist/list/filter/index.js